import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UserService } from '../../../auth/services/user.service';
import { BaseComponent } from '../../../shared/base-components/base.component';
import { SimpleCustomer } from '../../models/views/simple-customer.model';

@Component({
    selector: 'customer-search-container',
    templateUrl: './search-container.html'
})
export class CustomerSearchContainerComponent extends BaseComponent {

    public readonly INDIVIDUAL_TYPE = '1';
    public readonly ORGANIZATION_TYPE = '2';

    @Input() searchInfo: any;
    @Input() address: any;
    @Input() data: any = {};
    @Input() includeDeceased = true;
    @Input() defaultCustomerIdentificationTypeId: number;
    @Input() showCustomerType = true;
    @Input() enableAutoSelect = true;
    @Input() showHeader = true;
    @Input() showSearchCriteriaCheckboxes = true;
    @Input() showButtonLoading = false;
    @Input() maskSSN = false;
    @Input() isOverrideIndividualFormSubmit = false;
    @Input() customerTypeId = this.INDIVIDUAL_TYPE;
    @Output() onCreateCustomerSubmitted: EventEmitter<SimpleCustomer> = new EventEmitter();
    @Output() onCustomerNameClicked = new EventEmitter<number>();
    @Output() onCustomerSelected: EventEmitter<number> = new EventEmitter();

    public componentSubscription: any;
    public showAdd = false;
    public showIndividual: boolean;
    public showResults = false;
    public showSearch = true;
    public showSearchCriteria = true;
    private customerUserAgentCustomerNumbers: number[] = [];

    constructor(private userService: UserService) {
        super();
    }

    ngOnInit() {
        this.showIndividual = +this.customerTypeId === +this.INDIVIDUAL_TYPE;

        this.userService.getCustomerUserAgentCustomerNumbers()
            .subscribe((result) => {
                this.customerUserAgentCustomerNumbers = result;
                this.showResults = this.hasResultsinData() && this.hasNoValidationResults();
                this.showSearchCriteria = !this.hasResultsinData();
            }, () => {});
    }

    public addCustomer(value: any): void {
        this.searchInfo = value;
        this.showAdd = true;
        this.showSearch = false;
    }

    public customerAddCancel(): void {
        this.showAdd = false;
        this.showSearch = true;
    }

    public customerCreated(customerNumberId: number): void {
        this.onCustomerSelected.emit(customerNumberId);
    }

    public customerNameClicked(id: number): void {
        this.onCustomerNameClicked.emit(id);
    }

    public customerSelected(id: number): void {
        if (this.customerUserAgentCustomerNumbers.includes(id)) {
            this.handleValidationResult(this.userService.createAccessToUserDeniedValidationError());
        } else {
            this.onCustomerSelected.emit(id);
        }
    }

    public customerTypeChange(customerType: string): void {
        this.data = undefined;
        this.showIndividual = customerType === this.INDIVIDUAL_TYPE;
    }

    customerCreateSubmit(customer: SimpleCustomer): void {
        this.onCreateCustomerSubmitted.emit(customer);
    }

    reset() {
        this.data = {};
    }

    resultsReceived(response: any): void {
        this.clearValidationResults();
        this.showValidationComponent = false;
        if (this.oneResultIn(response) && this.enableAutoSelect) {
            this.selectCustomer(response);
        } else {
            this.data = response;
            this.showResults = true;
            this.showSearchCriteria = false;
        }
    }

    private hasNoValidationResults(): boolean {
        const resultsWithValResultsProp: any[] = this.data.results.filter(result => result.validationResults);
        const hasNoResultsWithValResultsProp = resultsWithValResultsProp.length === 0;
        const hasOnlyEmptyValidtionResults = resultsWithValResultsProp.some(result => !result.validationResults.length);
        return hasNoResultsWithValResultsProp || hasOnlyEmptyValidtionResults;
    }

    private hasResultsinData() {
        return this.moreThanZeroResultsIn(this.data);
    }

    private moreThanZeroResultsIn(value: any) {
        return !!value && !!value.results && value.results.length > 0;
    }

    private oneResultIn(value: any) {
        return this.moreThanZeroResultsIn(value) && value.results.length === 1;
    }

    private selectCustomer(response: any) {
        let selectedCustomerId = response.results[0].customerNumber;
        this.customerSelected(selectedCustomerId);
    }
}
